import { render, staticRenderFns } from "./alternatives.vue?vue&type=template&id=c76ae478&scoped=true"
import script from "./alternatives.vue?vue&type=script&lang=js"
export * from "./alternatives.vue?vue&type=script&lang=js"
import style0 from "./alternatives.vue?vue&type=style&index=0&id=c76ae478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76ae478",
  null
  
)

export default component.exports